export const ceilTo = (multiple: number) => (input: number) =>
  typeof multiple !== 'number' || multiple === 0
    ? 0
    : Math.round(Math.ceil(input / multiple) * multiple)
